import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import moment from "moment";
import { toast } from "react-toastify";

import "./form.css";
import iconEdit from "../img/iconEdit.svg";
import iconInitial from "../img/tabla/iconInitial.svg";

import { ModalProgress } from "../../modals/ModalProgress";
import { DialogInitialService } from "./DialogInitialService";
import { ModalListaGastos } from "../ModalListaGastos";

import { FormActions } from "./FormActions";
import { PptosFormModalDatosIniciales } from "./PptosFormModalDatosIniciales";
// import { PptosCondiciones } from './PptosCondiciones'

import { startGetGeneralGasto } from "../../../redux/actions/general";
import {
  iniLoadBudgetsDetail,
  iniAddTitle,
  iniCreateBudget,
} from "../../../redux/actions/pptosGastos";

import TablaPptos from "./tablaPresupuestos/TablaPptos";

import { BoxSupplier } from "./BoxSuppliers";
import { Eye, FileSliders, Pencil } from "lucide-react";

import { useBuy } from "../../../hooks/useBuy";
import { BoxTotals } from "./BoxTotals";
import { Tooltip } from "@mui/material";
import { ModoEjecucionItems } from "./ModoEjecucion/ModoEjecucionItems";

export const PptosGastosForm = () => {
  const dispatch = useDispatch();

  const urlParams = useParams();
  const { budgetId } = urlParams;

  const generalParams = useSelector((state) => state.general);
  const { openProgress, listaTiposDocumentos } = generalParams;

  const detailBudget = useSelector((state) => state.pptoGasto.detail);
  const { detailBuy, initCreateBuy } = useBuy();

  const {
    id,
    numero,
    referencia,
    items,
    reading_mode,
    fecha_asignacion_ini,
    fecha_asignacion_fin,
    temporalidad,
    info_by_suppliers = [],
    separacion_miles,
    separacion_decimales,
    simbolo,
  } = detailBudget;

  const [open, setOpen] = useState(false);
  const [openInitialServices, setOpenInitialServices] = useState(false);
  const [openListCompras, setOpenListCompras] = useState(false);
  const [itemPptoSelected, setItemPptoSelected] = useState(null);
  const [openNewBuy, setOpenNewBuy] = useState(false);
  const [isEditMode, setIsEditMode] = useState(
    parseInt(budgetId) > 0 ? false : true,
  );

  const addTitle = () => {
    dispatch(iniAddTitle(items));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadIni = useCallback(async () => {
    if (parseInt(budgetId) > 0) {
      dispatch(iniLoadBudgetsDetail(budgetId));
    }
  }, [dispatch, budgetId]);

  const handleCloseListCompras = () => {
    setOpenListCompras(false);
  };

  const handleOpenListCompras = (by, item = null) => {
    setItemPptoSelected(item);
    setOpenListCompras(true);
  };

  const handleAddBuy = async () => {
    const itemsSelected = await getItemsSelected(items);

    if (itemsSelected.length === 0) {
      toast.warning("Falta seleccionar ítem para comprar");
      return false;
    }

    await initCreateBuy({
      origen: "gastos_internos",
      itemsSelected,
      detailBudget,
      generalParams,
    });

    setOpenNewBuy(true);
  };

  const getItemsSelected = async (titles) => {
    let itemsSelected = [];

    for (let i = 0; i < titles.length; i++) {
      const currentTitle = titles[i];
      const filtered = currentTitle.items.filter((it) => it.selected === true);

      for (let x = 0; x < filtered.length; x++) {
        itemsSelected = [...itemsSelected, filtered[x]];
      }
    }

    return itemsSelected;
  };

  useEffect(() => {
    dispatch(startGetGeneralGasto());
  }, [dispatch]);

  useEffect(() => {
    loadIni();

    return () => {
      dispatch(iniCreateBudget());
    };
  }, [dispatch, budgetId, loadIni]);

  return (
    <div className="p-pptos">
      {openProgress && <ModalProgress />}

      {open && (
        <PptosFormModalDatosIniciales
          open={open}
          handleClose={handleClose}
          title="Datos del presupuesto"
        />
      )}

      {openListCompras && (
        <ModalListaGastos
          open={openListCompras}
          handleClose={handleCloseListCompras}
          title="Gastos del presupuesto"
          origen="gastos_internos"
          item={itemPptoSelected}
        />
      )}

      <div className="bg-white rounded-lg p-3 flex justify-between">
        <div>
          <h2 className="flex flex-col gap-1">
            <div className="flex items-center gap-1">
              <div className="text-xs text-gray-600 uppercase">
                {id === null || id === 0
                  ? "Nuevo ppto de gasto"
                  : "ppto de gasto"}{" "}
                #{numero}
              </div>
              {reading_mode && (
                <div className="ms-2 text-[--primary-color] font-bold flex text-xs items-center">
                  <Eye size={15} />
                  <span className="ms-1 uppercase">Modo: lectura</span>
                </div>
              )}
            </div>

            <div className="flex items-center uppercase font-semibold gap-2">
              <span className="text-base">{referencia}</span>
              <span>
                <img
                  className="cursor-pointer"
                  src={iconEdit}
                  alt="img editar"
                  title="editar datos iniciales"
                  onClick={() => setOpen(true)}
                />
              </span>
            </div>
          </h2>

          {temporalidad !== "mensual" ? (
            <div>
              <span className="">
                <label>Vigencia:</label>
                <span className="ms-1">
                  {moment(fecha_asignacion_ini).format("DD-MM-YYYY")}
                </span>
              </span>
              <span>—</span>
              <span className="ms-1">
                <span>{moment(fecha_asignacion_fin).format("DD-MM-YYYY")}</span>
              </span>
            </div>
          ) : (
            <div style={{ fontSize: "14px", color: "#595759" }}>
              <span>
                <label>Tiempo:</label>
                <span className="ms-1">{temporalidad}</span>
              </span>
              <span className="p-f-linea">|</span>
              <span>
                <label>Fecha presupuesto:</label>
                <span className="ms-1">
                  {moment(fecha_asignacion_ini).format("DD-MM-YYYY")}
                </span>
              </span>
            </div>
          )}
        </div>
        <div className="flex justify-start gap-2 me-2 items-center">
          <FormActions
            loadIniBudget={loadIni}
            setOpenNewBuy={setOpenNewBuy}
            openNewBuy={openNewBuy}
            initCreateBuy={initCreateBuy}
            detailBuy={detailBuy}
            getItemsSelected={getItemsSelected}
            handleAddBuy={handleAddBuy}
          />
        </div>
      </div>

      <BoxTotals />

      <div className="row mt-3 p-pptos-form-box">
        {" "}
        {/* bloque */}
        {id > 0 && (
          <div className="flex justify-between items-center">
            <div>
              <button
                className="p-open-condicion"
                onClick={() => handleOpenListCompras("general", null)}
              >
                Ver gastos
              </button>
            </div>
            <div className="flex gap-3 pe-2">
              <Tooltip title="Vista ejecución">
                <button onClick={() => setIsEditMode(false)}>
                  <FileSliders
                    size={16}
                    color={`${!isEditMode ? "#8E24AA" : "gray"}`}
                  />
                </button>
              </Tooltip>
              <Tooltip title="Vista edición">
                <button onClick={() => setIsEditMode(true)}>
                  <Pencil
                    size={16}
                    color={`${isEditMode ? "#8E24AA" : "gray"}`}
                  />
                </button>
              </Tooltip>
            </div>
          </div>
        )}
        <div className="col p-pptos-form-tabla p-0">
          {isEditMode ? (
            <div className="table-responsive">
              {items?.length > 0 ? (
                <TablaPptos
                  addTitle={addTitle}
                  listaTiposDocumentos={listaTiposDocumentos}
                  handleOpenListCompras={handleOpenListCompras}
                  isEditMode={isEditMode}
                />
              ) : (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                  <img src={iconInitial} alt="Agregar servicios" />
                  <h3
                    style={{
                      color: "#78667E",
                      fontSize: "16px",
                      marginTop: "15px",
                    }}
                  >
                    Empieza agregando ítems para crear tu presupuesto
                  </h3>
                  <button
                    className="btn p-btn-primary mt-3"
                    onClick={addTitle}
                    style={{ width: "200px" }}
                  >
                    <i className="bi bi-plus"></i> Agregar ítems
                  </button>
                </div>
              )}
            </div>
          ) : (
            <ModoEjecucionItems
              items={items}
              separacion_miles={separacion_miles}
              separacion_decimales={separacion_decimales}
              simbolo={simbolo}
              handleOpenListCompras={handleOpenListCompras}
            />
          )}
        </div>
        {info_by_suppliers.length > 0 && (
          <div className="mt-2">
            <BoxSupplier
              suppliers={info_by_suppliers}
              separacion_miles={separacion_miles}
              separacion_decimales={separacion_decimales}
              simbolo={simbolo}
            />
          </div>
        )}
        {openInitialServices && (
          <DialogInitialService
            open={openInitialServices}
            setOpen={setOpenInitialServices}
          />
        )}
      </div>
    </div>
  );
};
